var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"item-text":_vm.ownerText,"label":"Ingrese razón social o ruc","dense":"","outlined":"","hide-details":"","persistent-placeholder":"","clearable":"","item-value":_vm.entry ? _vm.entry : 'document',"value":_vm.owner,"items":_vm.owners,"loading":_vm.loading},on:{"input":(v) => _vm.setValue(v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }